//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { EthAddr } from '@shared/SchemaTypes'
import * as React from 'react'
import { ReactElement, useEffect } from 'react'

import { RoleEnum } from '@shared/Enums'

import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import { Fab } from '@mui/material'
import { blue } from '@mui/material/colors'

import { useOtChainState } from '@react/redux/store'

import { uploadLogo, urlForFile } from '@react/apx/AwsApx'

export default function PoolEditIcon(props: {
  poolAddr: EthAddr
  setHasIcon?: (value: boolean) => void
}): ReactElement {
  const poolAddr = props.poolAddr
  const size = 50
  const [hasImage, setHasImage] = React.useState<boolean | undefined>(undefined)
  const { userConnection, stageConfiguration, cognitoUser } = useOtChainState()
  const stageName = stageConfiguration.stageName
  const restAPIKey = stageConfiguration.restAPIKey
  const { roleEnum } = userConnection ?? {}

  const handleLogoSelect = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0]
    if (file && poolAddr && cognitoUser) {
      const asyncFunction = async (): Promise<void> => {
        if (stageName && restAPIKey) {
          await uploadLogo(stageName, poolAddr, file, restAPIKey, cognitoUser)
          const url = urlForFile(stageName, `${poolAddr}/logo.png`)
          await fetch(url, { cache: 'reload', mode: 'no-cors' })
          document.body.querySelectorAll(`img[src='${url}']`).forEach((element: Element): void => {
            const img = element as HTMLImageElement
            if (img) {
              img.src = url
            }
          })
          setHasImage(true)
          if (props.setHasIcon) {
            props.setHasIcon(true)
          }
        }
      }
      asyncFunction().catch((e) => {
        console.error(e)
      })
    }
  }

  useEffect(() => {
    if (stageName && restAPIKey) {
      const url = urlForFile(stageName, `${poolAddr}/logo.png`)
      const img = new Image(50, 50)
      img.src = url
      if (img.complete) {
        setHasImage(true)
        if (props.setHasIcon) {
          props.setHasIcon(true)
        }
      }
      img.onload = () => {
        setHasImage(true)
        if (props.setHasIcon) {
          props.setHasIcon(true)
        }
      }
      img.onerror = () => {
        setHasImage(false)
        if (props.setHasIcon) {
          props.setHasIcon(false)
        }
      }
    }
  }, [poolAddr, stageName])
  if (hasImage && stageName) {
    return (
      <img
        style={{ width: size, height: size, margin: 'auto' }}
        src={urlForFile(stageName, `${poolAddr}/logo.png`)}
        alt={poolAddr}
      />
    )
  }
  if (roleEnum === RoleEnum.POOL_ADMIN && hasImage === false) {
    return (
      <>
        <input
          id="contained-button-file"
          style={{ display: 'none' }}
          type="file"
          accept="image/png"
          onChange={handleLogoSelect}
        />
        <label htmlFor="contained-button-file">
          <Fab
            component="span"
            style={{
              color: blue[900],
              margin: 10,
            }}
          >
            <AddPhotoAlternateIcon />
          </Fab>
        </label>
      </>
    )
  }
  return <></>
}
